import DoubleClickZoom from 'ol/interaction/DoubleClickZoom.js';
export default class mapEvent{
    constructor(){}
    mapEventDbClick(id){
        let mapid = document.getElementById(id);
        mapid.addEventListener("dblclick", () => {
        let zoom = systemConfig.mapApi.getZoomInfo();
        if (zoom.zoom < 18) {
          systemConfig.mapApi.addInteraction(new DoubleClickZoom())
          // systemConfig.mapApi.setZoomLevel(zoom.zoom + 1);
        }
      });
    }
}